(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/information-panels/information-panels.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/information-panels/information-panels.js');
"use strict";

const {
  useMemo
} = React;
const {
  Card,
  CardBody
} = svs.ui.ReactCard;
const {
  Grid,
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const Icon = svs.ui.ReactIcon;
const {
  useBreakpointGreaterThan
} = svs.ticket_partner.sharedComponents.hooks;
const InformationPanels = _ref => {
  let {
    articles
  } = _ref;
  const [greaterThan] = useBreakpointGreaterThan('sm');
  const flexDirection = greaterThan ? 'u-flex-row' : 'u-flex-column';

  const colOrder = useMemo(() => {
    const cmsArticles = [...articles];
    if (articles.length === 1) {
      return [{
        col: [articles[0]],
        singleColumn: true
      }];
    }
    const middleIndex = Math.ceil(cmsArticles.length / 2);
    const deleteCount = Math.floor(cmsArticles.length / 2);
    const columnLeft = cmsArticles.splice(0, deleteCount);
    const columnRight = cmsArticles.splice(-middleIndex);
    return [{
      col: columnLeft
    }, {
      col: columnRight
    }];
  }, [articles]);
  const Columns = _ref2 => {
    let {
      order
    } = _ref2;
    return order.map((_ref3, i) => {
      let {
        col,
        singleColumn = false
      } = _ref3;
      return React.createElement(GridCol, {
        am: singleColumn ? 12 : 6,
        className: "u-flex u-flex-wrap",
        key: _.uniqueId(i),
        sm: 12
      }, col.map((article, i) => article && React.createElement(Card, {
        className: "margin-1 w100",
        key: _.uniqueId(i)
      }, React.createElement(CardBody, null, React.createElement("h2", {
        className: "u-flex card-title u-flex-justify-content-center"
      }, article.icon && React.createElement(Icon, {
        icon: article.icon,
        size: "500"
      }), "\xA0", React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: article.title
        }
      })), React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: article.body
        }
      })))));
    });
  };
  return articles.length ? React.createElement(GridRow, {
    className: "bg-tur-100 section-full-width padding-bottom-2 padding-top-2 margin-2",
    gutter: {
      y: 0
    }
  }, React.createElement(GridCol, {
    className: "u-text-left",
    lg: {
      col: 8
    },
    md: {
      col: 10
    },
    sm: {
      col: 12
    },
    xl: {
      col: 6
    },
    xs: 12
  }, React.createElement(Grid, null, React.createElement(GridRow, null, React.createElement("div", {
    className: "u-flex ".concat(flexDirection)
  }, React.createElement(Columns, {
    order: colOrder
  })))))) : React.createElement("div", null);
};
svs.ticket_partner.sharedComponents.informationPanels.InformationPanels = InformationPanels;

 })(window);